"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
var _RunasDatasourceSelectionStepResponse = _interopRequireDefault(require("../../api/auth/RunasDatasourceSelectionStepResponse"));
var _ReturnToLoginLink = _interopRequireDefault(require("./ReturnToLoginLink"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const decorateErrorMessage = msg => /*#__PURE__*/_react.default.createElement("p", {
  className: "help is-danger has-text-left"
}, msg);
class RunasDatasourceSelectionStep extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      errorMessage: '',
      dataSources: [{
        dskey: 'SSNC',
        text: 'SS&C'
      }, {
        dskey: 'ICMARC',
        text: 'MissionSquare'
      }],
      selectedDataSource: ''
    };
    this.returnToLogin = this.returnToLogin.bind(this);
  }
  submit(e) {
    const {
      stepResponse
    } = this.props;
    const {
      selectedDataSource
    } = this.state;
    const defaultDataSourceKey = stepResponse?.additionalData?.DefaultDatasource || 'ICMARC';
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    const step = new _RunasDatasourceSelectionStepResponse.default();
    step.datasource = selectedDataSource || defaultDataSourceKey;
    this.props.listener(this, step);
  }
  returnToLogin(e) {
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    this.props.listener('InitializeAuthentication', null);
    this.props.history.push(_ApplicationContext.ApplicationContext.getLoginPath());
  }
  change(e) {
    this.setState({
      selectedDataSource: e.target.value
    });
  }
  render() {
    const {
      rawErrorMessage,
      isLoading,
      message,
      dataSources,
      selectedDataSource
    } = this.state;
    const {
      stepResponse
    } = this.props;
    const dataSourceMessage = stepResponse?.additionalData?.message || message || 'Press next to continue with the default datasource, or select a different datasource';
    const disabled = typeof rawErrorMessage !== 'undefined' && rawErrorMessage;
    const defaultDataSourceKey = stepResponse?.additionalData?.DefaultDatasource || 'ICMARC';
    const defaultDataSources = dataSources.filter(ds => ds.dskey === defaultDataSourceKey);
    const defaultDataSources2 = defaultDataSources.map(ds => {
      const ds2 = ds;
      ds2.default = true;
      ds2.checked = true;
      return ds2;
    });
    const orderedDataSources = [...defaultDataSources2, ...dataSources.filter(ds => ds.dskey !== defaultDataSourceKey)];
    let orderedDataSources2 = orderedDataSources;
    if (selectedDataSource) {
      orderedDataSources2 = orderedDataSources.map(ds => {
        const ds2 = ds;
        if (ds2.dskey === selectedDataSource) {
          ds2.checked = true;
        } else {
          ds2.checked = false;
        }
        return ds2;
      });
    }
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement("form", {
      id: "otpForm"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "login-box content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "px-4"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title"
    }, "Datasource"), /*#__PURE__*/_react.default.createElement("p", {
      className: "subtitle has-text-left pb-4"
    }, dataSourceMessage), decorateErrorMessage(rawErrorMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, orderedDataSources2.map((ds, i) => /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-text-left pl-2",
      key: `ds_${ds.dskey}_${i}`
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: "label is-size-4"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: 'radio mr-1',
      type: "radio",
      id: `ds_id_${ds.dskey}_${i}`,
      name: "datasource",
      onChange: e => this.change(e),
      value: ds.dskey,
      required: true,
      checked: ds.checked
    }), ds.default && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, ds.text, " (Default)"), !ds.default && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, ds.text))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "field mt-4"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "is-primary is-fullwidth",
      handleClick: e => this.submit(e),
      disabled: disabled
    }, "Next"))), /*#__PURE__*/_react.default.createElement(_ReturnToLoginLink.default, {
      returnToLogin: this.returnToLogin
    })))));
  }
}
RunasDatasourceSelectionStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  }),
  stepResponse: _propTypes.default.shape({
    additionalData: _propTypes.default.shape({
      message: _propTypes.default.string,
      DefaultDatasource: _propTypes.default.string
    })
  })
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(RunasDatasourceSelectionStep);
//# sourceMappingURL=RunasDatasourceSelectionStep.js.map